import styled, { keyframes } from 'styled-components';

// Add spinner animation keyframe
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Add loading spinner component
export const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: ${spin} 0.8s linear infinite;
`;

export const SpinnerWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
`;

// Add a new button content wrapper for flex layout
export const ButtonContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
  
  span {
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 240px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  gap: 59px;
  
  @media (max-width: 1700px) {
    padding: 0 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 0 80px;
    gap: 40px;
  }

  @media (max-width: 1200px) {
    gap: 30px;
  }
  
  @media (max-width: 1050px) {
    gap: 20px;
    padding: 0 40px;
  }
  
  @media (max-width: 900px) {
    flex-direction: column;
    padding: 0 20px;
    min-height: unset;
    gap: 22px;
  }

  @media (max-width: 480px) {
    padding: 0 20px;
  }
`;

export const LeftSection = styled.div`
  width: 671px;
  position: relative;
  height: auto;
  min-height: 100vh;
  
  @media (max-width: 1440px) {
    width: 48%;
    min-width: 400px;
  }

  @media (max-width: 1200px) {
    width: 45%;
    min-width: 380px;
  }
  
  @media (max-width: 1050px) {
    width: 42%;
    min-width: 350px;
  }
  
  @media (max-width: 900px) {
    width: 100%;
    min-width: auto;
    min-height: auto;
  }
`;

export const RightSection = styled.div`
  width: 710px;
  height: auto;
  
  @media (max-width: 1440px) {
    width: 48%;
    min-width: 500px;
  }

  @media (max-width: 1200px) {
    width: 51%;
    min-width: 470px;
  }
  
  @media (max-width: 1050px) {
    width: 54%;
    min-width: 450px;
  }
  
  @media (max-width: 900px) {
    width: 100%;
    min-width: auto;
  }
`;

export const ContentWrapper = styled.div`
  padding-top: 160px;
  padding-bottom: 130px;
  
  @media (max-width: 1024px) {
    padding-top: 80px;
    padding-bottom: 0;
    height: auto;
    min-height: unset;
  }

  @media (max-width: 900px) {
    padding-top: 20px;
    padding-bottom: 0px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

// 왼쪽 영역 컴포넌트
export const LeftFrame = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 50px;
  display: inline-flex;
  
  @media (max-width: 900px) {
    gap: 30px;
  }
`;

export const ContactUsHeading = styled.h1`
  align-self: stretch;
  color: #1D1D1D;
  font-size: 72px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  line-height: 96px;
  word-wrap: break-word;
  margin: 0;
  
  @media (max-width: 900px) {
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
  }
`;

export const TitleSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: flex;
`;

export const SubTitle = styled.div`
  align-self: stretch;
  color: #1D1D1D;
  font-size: 32px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  line-height: 46px;
  word-wrap: break-word;
  
  @media (max-width: 900px) {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const Description = styled.div`
  align-self: stretch;
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  
  @media (max-width: 900px) {
    font-weight: 400;
    line-height: 28px;
  }
`;

export const ButtonGroup = styled.div`
  min-width: 250px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: flex;
  
  @media (max-width: 900px) {
    display: none;
  }
`;

export const Button = styled.div`
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  display: inline-flex;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    div {
      color: #FF4F00;
    }
  }
`;

export const ButtonText = styled.div`
  color: #5C5C5C;
  font-size: 24px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 36px;
  word-wrap: break-word;
  white-space: nowrap;
  transition: color 0.2s ease;
  
  @media (max-width: 900px) {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const MapIcon = styled.div`
  width: 36px;
  height: 36px;
  position: relative;
  overflow: hidden;
  margin-right: 198px;
`;

export const IconBackground = styled.div`
  width: 36px;
  height: 36px;
  left: 0px;
  top: 0px;
  position: absolute;
`;

export const IconContent = styled.div`
  width: 24.75px;
  height: 31.50px;
  left: 5.62px;
  top: 2.25px;
  position: absolute;
  background: #FF4F00;
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AddressText = styled.span`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  display: block;
`;

export const EmailText = styled.span`
  color: #1D1D1D;
  font-size: 24px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  line-height: 36px;
  word-wrap: break-word;
  display: block;
`;

// 우측 영역 컴포넌트
export const RightContentTitle = styled.div`
  color: #1D1D1D;
  font-size: 24px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  line-height: 36px;
  word-wrap: break-word;
  margin-bottom: 50px;

  @media (max-width: 900px) {
    margin-bottom: 40px;
    padding-top: 0;
  }
`;

// InfoSection 추가 (누락된 컴포넌트)
export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  @media (max-width: 900px) {
    margin-top: 86px;
    margin-bottom: 50px;
  }
`;

// 라벨 스타일 추가
export const FormLabel = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  @media (max-width: 900px) {
    margin-bottom: 0;
  }
`;

export const LabelText = styled.span`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  line-height: 28px;
  word-wrap: break-word;
`;

export const RequiredMark = styled.span`
  color: #FF4F00;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  line-height: 28px;
  word-wrap: break-word;
  margin-left: 2px;
`;

export const FormSection = styled.div`
  margin-top: 40px;

  @media (max-width: 900px) {
    & > *:first-child {
      margin-bottom: 20px;
    }
    padding-bottom: 24px;
  }
`;

// 칩(태그) 관련 스타일 수정
export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 50px;
  
  @media (max-width: 900px) {
    row-gap: 10px;
    column-gap: 6px;
    margin-bottom: 60px;
  }
`;

export const Chip = styled.div<{ active: boolean }>`
  height: 48px;
  width: 170px;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
  box-sizing: border-box;
  background-color: ${({ active }) => (active ? '#1D1D1D' : '#FFFFFF')};
  border: ${({ active }) => (active ? 'none' : '1px solid #E0E0E0')};
  
  @media (max-width: 900px) {
    height: 48px;
    width: auto;
    padding: 0 20px;
    border-radius: 24px;
  }
`;

export const ChipText = styled.span<{ active: boolean }>`
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#FFFFFF' : '#1D1D1D')};
  white-space: nowrap;
  
  @media (max-width: 900px) {
    font-size: 14px;
  }
`;

// 입력 필드 영역 스타일 추가
export const InputRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 50px;
  
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 40px;
    margin-bottom: 40px;
  }
`;

export const InputColumn = styled.div`
  width: calc(50% - 10px);
  display: flex;
  flex-direction: column;
  gap: 0;
  
  @media (max-width: 900px) {
    width: 100%;
    gap: 10px;
  }
`;

// 텍스트 필드 스타일 수정
export const TextField = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid #DCDCDC;
  display: flex;
  align-items: center;
  position: relative;
  gap: 8px;
`;

export const InputField = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #1D1D1D;
  background: transparent;
  padding: 0;
  
  &::placeholder {
    color: #DCDCDC;
  }
`;

// 드롭다운 스타일 수정
export const SelectField = styled.select`
  width: 100%;
  border: none;
  outline: none;
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  color: #1D1D1D;
  background: transparent;
  padding: 0;
  appearance: none;
  cursor: pointer;
  
  &:invalid {
    color: #DCDCDC;
  }
  
  option {
    color: #1D1D1D;
  }
`;

export const PlaceholderText = styled.span`
  color: #DCDCDC;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  line-height: 26px;
  word-wrap: break-word;
  flex: 1;
`;

export const UnitText = styled.span`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  white-space: nowrap;
  flex-shrink: 0;
  padding-left: 4px;
`;

// 예산 드롭다운 스타일 수정
export const DropdownField = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid #DCDCDC;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  display: inline-flex;
  cursor: pointer;
`;

export const DropdownPlaceholder = styled.span`
  color: #DCDCDC;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  flex: 1;
`;

export const ArrowIconWrapper = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  overflow: hidden;
`;

export const ArrowIconInner = styled.div`
  width: 10px;
  height: 5px;
  left: 3px;
  top: 6px;
  position: absolute;
  outline: 2px solid #5C5C5C;
  outline-offset: -1px;
`;

// 문의 내용 영역 스타일 수정
export const TextAreaSection = styled.div`
  width: 100%;
  margin-bottom: 50px;
  
  @media (max-width: 900px) {
    margin-bottom: 62px;
    & > ${FormLabel} {
      margin-bottom: 10px;
    }
  }
`;

export const TextAreaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  @media (max-width: 900px) {
    gap: 20px;
  }
`;

export const TextareaFrame = styled.div`
  width: 100%;
  height: 320px;
  min-height: unset;
  padding: 12px 20px;
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  box-sizing: border-box;
  
  @media (max-width: 900px) {
    height: auto;
    min-height: 300px;
    max-height: 450px;
    padding: 12px 20px;
  }
`;

export const TextAreaInput = styled.textarea`
  width: 100%;
  height: 260px;
  min-height: unset;
  border: none;
  outline: none;
  resize: none;
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #1D1D1D;
  white-space: pre-wrap;
  overflow: visible;
  
  &::placeholder {
    color: #DCDCDC;
    font-weight: 400;
    white-space: pre-line;
    overflow: visible;
    line-height: 1.6;
  }
  
  @media (max-width: 900px) {
    height: 410px;
    min-height: unset;
  }
`;

// 파일 첨부 영역 스타일 수정
export const FileAddSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }
`;

export const FileButton = styled.button`
  height: 40px;
  min-width: 94px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 20px;
  background-color: #1D1D1D;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #333333;
  }
  
  &:disabled {
    background-color: #DCDCDC;
    cursor: not-allowed;
  }
  
  @media (max-width: 900px) {
    width: 100%;
    height: 40px;
  }
`;

export const FileButtonText = styled.span`
  color: #FFFFFF;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  line-height: 26px;
  word-wrap: break-word;
`;

export const CaptionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  
  @media (max-width: 900px) {
    margin-top: 8px;
    width: 100%;
  }
`;

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  overflow: hidden;
`;

export const IconInner = styled.div`
  width: 13px;
  height: 13px;
  left: 1.5px;
  top: 1.5px;
  position: absolute;
  background: #DCDCDC;
`;

export const CaptionText = styled.span`
  color: #5C5C5C;
  font-size: 12px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  line-height: 16px;
  word-wrap: break-word;
  
  @media (max-width: 900px) {
    flex: 1;
  }
`;

// 의뢰인 정보 영역 스타일
export const ClientInfoSection = styled.div`
  width: 100%;
  margin-top: 80px;
`;

export const ClientInfoTitle = styled.div`
  color: #1D1D1D;
  font-size: 24px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  line-height: 36px;
  word-wrap: break-word;
  margin-bottom: 50px;
  
  @media (max-width: 900px) {
    margin-top: 30px;
  }
`;

export const ClientInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
  
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 32px;
    margin-bottom: 32px;
  }
`;

// 동의 항목 스타일
export const AgreementSection = styled.div`
  width: 100%;
  margin-top: 70px;
  margin-bottom: 50px;
`;

export const AgreementRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 30px;
  
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const CheckboxContainer = styled.div`
  width: auto;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  display: inline-flex;
  cursor: pointer;
  
  &:nth-child(2) {
    margin-left: 50px;
    
    @media (max-width: 900px) {
      margin-left: 0;
    }
  }
`;

export const Checkbox = styled.div<{ checked?: boolean }>`
  width: 26px;
  height: 26px;
  position: relative;
  overflow: hidden;
  background: transparent;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
  border: none;
  box-sizing: border-box;
  
  img {
    width: 26px;
    height: 26px;
    filter: ${({ checked }) => checked ? 'brightness(0) saturate(100%) invert(39%) sepia(95%) saturate(7461%) hue-rotate(2deg) brightness(106%) contrast(106%)' : 'none'};
  }
`;

export const CheckboxInner = styled.div<{ checked?: boolean }>`
  width: 21.13px;
  height: 21.13px;
  left: 2.44px;
  top: 2.44px;
  position: absolute;
  background: ${({ checked }) => checked ? '#1D1D1D' : '#F0F0F0'};
  transition: background-color 0.2s ease;
`;

export const AgreementText = styled.div`
  display: flex;
  align-items: center;
`;

export const HighlightText = styled.span`
  color: #FF4F00;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  text-decoration: underline;
  line-height: 26px;
  word-wrap: break-word;
  cursor: pointer;
`;

export const NormalText = styled.span`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  line-height: 26px;
  word-wrap: break-word;
`;

// 제출 버튼 스타일
export const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 62px;
`;

export const SubmitButton = styled.button`
  width: 200px;
  min-width: 140px;
  height: 60px;
  background-color: #FF4F00;
  color: white;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 30px;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #E64800;
  }
  
  &:disabled {
    background-color: #DCDCDC;
    cursor: not-allowed;
  }

  @media (max-width: 900px) {
    width: 335px;
    min-width: 335px;
    height: 60px;
    background-color: #FF4F00;
    border-radius: 50px;
    font-size: 16px;
    padding: 16px 30px;
    margin-top: 110px;
    &:hover {
      background-color: #E64800;
    }
  }
`;

export const ConfirmButton = styled.button`
  min-width: 100%;
  height: 60px;
  background-color: #FF4F00;
  color: white;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  margin-top: 20px;
  padding: 16px 30px;
  box-sizing: border-box;
  
  &:disabled {
    background-color: #DCDCDC;
    cursor: not-allowed;
  }
`;

// 파일 첨부 관련 스타일 추가
export const AddedFileContainer = styled.div`
  width: 100%;
  padding: 12px 10px;
  background: white;
  border-radius: 8px;
  outline: 1px solid #F0F0F0;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  display: inline-flex;
  margin-bottom: 0;
  box-sizing: border-box;
  
  & + & {
    margin-top: 10px;
  }
`;

export const FileIcon = styled.div`
  padding-top: 4px;
  padding-left: 4px;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  display: flex;
`;

export const FileIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  position: relative;
`;

export const FileTextContent = styled.div`
  flex: 1;
  height: 44px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
  overflow: hidden;
`;

export const FileName = styled.span`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  line-height: 28px;
  word-wrap: break-word;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const FileSize = styled.span`
  color: #999999;
  font-size: 12px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  line-height: 16px;
  word-wrap: break-word;
`;

export const DeleteIconWrapper = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
`;

export const DeleteIconInner = styled.div`
  width: 9px;
  height: 9px;
  left: 3.5px;
  top: 3.5px;
  position: absolute;
  background: #DCDCDC;
  outline: 2px solid #DCDCDC;
  outline-offset: -1px;
`;

// PDF 아이콘 관련 스타일
export const PDFIconBackground = styled.div`
  width: 19.73px;
  height: 25.92px;
  left: 4px;
  top: 2px;
  position: absolute;
  opacity: 0.30;
  background: #FF3E4C;
`;

export const PDFIconElements = styled.div`
  position: absolute;
  background: #FF3E4C;
`;

export const PDFIconWhite = styled.div`
  position: absolute;
  background: white;
`;

// 모바일용 버튼 그룹 수정
export const MobileButtonGroup = styled.div`
  display: none;
  
  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-top: 30px;
  }
`;

// 모바일 버튼 가로 배열 컨테이너 추가
export const MobileButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
`;

// 모바일용 문의하기 버튼 스타일
export const MobileInquiryButton = styled.button`
  height: 50px;
  padding: 12px 30px;
  background-color: #1D1D1D;
  color: white;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #000000;
  }
`;

// MobileButton 스타일 컴포넌트 추가
export const MobileButton = styled(Button)`
  @media (max-width: 900px) {
    display: flex;
    width: auto;
    font-size: 14px;
  }
`;

export const CustomBudgetDropdown = styled.div`
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  z-index: 10;
  padding: 6px 0;
`;

export const CustomBudgetOption = styled.div`
  padding: 12px 20px;
  font-size: 16px;
  color: #1D1D1D;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: #F8F8F8;
  }
  &:active {
    background: #F0F0F0;
  }
`;

// Modify MobileFixedButtonContainer to be a regular div
export const MobileButtonContainer = styled.div`
  display: none;
  
  @media (max-width: 900px) {
    display: block;
    width: 100%;
    background: white;
  }
`;

// Add error modal styles
export const ErrorModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

export const ErrorModalContent = styled.div`
  background: white;
  width: 335px;
  border-radius: 20px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

export const ErrorIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  img {
    width: 48px;
    height: 48px;
  }
`;

export const ErrorMessage = styled.div`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
  word-break: keep-all;
`;

export const ErrorModalButton = styled.button`
  width: 100%;
  height: 50px;
  background: #FF4F00;
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #E64800;
  }
`;